var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.165,
    height: 69.292,
    viewBox: "0 0 56.165 69.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.41,
    x2: 0.5,
    y2: 2.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.302
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobiledes-stop",
    transform: "translate(0.002 -0.167)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 2.808,
    cy: 2.814,
    rx: 2.808,
    ry: 2.814,
    transform: "translate(25.273 63.83)",
    fill: "#9e8eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M23.6,70.279C10.218,69.335,0,64.226,0,58.068,0,51.238,12.573,45.7,28.081,45.7s28.081,5.538,28.081,12.367c0,6.14-10.162,11.232-23.485,12.2-3.894.8-4.6,2.64-4.6,2.64a7.949,7.949,0,0,0-4.48-2.629Z",
    transform: "translate(0 -10.016)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M23.6,55.969a28.081,28.081,0,1,1,9.076-.019,8.707,8.707,0,0,0-4.6,6S26.307,56.919,23.6,55.969Z",
    fill: "#9e8eee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mobileapp",
    transform: "translate(17.319 17.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M121.8,104.576V95.188a1.49,1.49,0,0,0-1.488-1.488h-7.819A1.49,1.49,0,0,0,111,95.188V108.3a1.49,1.49,0,0,0,1.488,1.488h7.819c1.4,0,1.488-1.488,1.488-1.488S121.9,104.789,121.8,104.576Z",
    transform: "translate(-105.738 -89.716)",
    fill: "#fff",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M85.031,14.121V3.4a1.7,1.7,0,0,0-1.7-1.7H74.4a1.7,1.7,0,0,0-1.7,1.7V18.368a1.7,1.7,0,0,0,1.7,1.7H83.33a1.7,1.7,0,0,0,1.7-1.7.85.85,0,1,1,1.7,0,3.406,3.406,0,0,1-3.4,3.4H74.4a3.406,3.406,0,0,1-3.4-3.4V3.4A3.406,3.406,0,0,1,74.4,0H83.33a3.406,3.406,0,0,1,3.4,3.4V14.121a.85.85,0,1,1-1.7,0ZM78.016,17.9a.85.85,0,1,0,.85-.85A.853.853,0,0,0,78.016,17.9Zm1.7-13.181a.85.85,0,1,0,0-1.7h-1.7a.85.85,0,1,0,0,1.7Zm2.976,10.46a.853.853,0,0,0,.85-.85V9.146a.85.85,0,0,0-1.7,0v4.337h-.85V7.445a.85.85,0,0,0-1.7,0v6.038h-.85V10.847a.85.85,0,1,0-1.7,0v2.636h-.85V9.146a.85.85,0,1,0-1.7,0v5.187a.853.853,0,0,0,.85.85Z",
    transform: "translate(-67.439 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.f37a74522a8cebbede89c22646cbc594.svg";
export { ForwardRef as ReactComponent };